import { Connection } from 'honeygrid-types/validators-and-types/ConnectionTypes'
import { FC } from 'react'

interface GoogleAdsConnectionMainContentProps {
	connection: Connection
}

export const GoogleAdsConnectionMainContent: FC<GoogleAdsConnectionMainContentProps> = ({
	connection,
}) => {
	return (
		<div>
			<h1>Google Ads Main Content for {connection.name}</h1>
		</div>
	)
}
